import * as React from 'react';

import { LinkArea } from '../LinkArea';
import { formatOfferPrice } from '../../utils/formatOfferPrice';
import { redesignedAddressToString } from '../../utils/formatters/redesignedAddress';
import { TRecommendation } from '../../types/recommendation';
import * as styles from './RecommendationOfferDesktop.css';

type TRecommendationOfferDesktopProps = {
  offer: TRecommendation;
  geoInformation: React.ReactNode;
  favoriteButton: React.ReactNode;
  labels: React.ReactNode;
  pageTypeSource?: string | null;
  position: number;
  onClick(offer: TRecommendation, position: number): void;
};

export const RecommendationOfferDesktop: React.FC<TRecommendationOfferDesktopProps> = ({
  offer,
  favoriteButton,
  geoInformation,
  labels,
  pageTypeSource,
  position,
  onClick,
}) => {
  const { photos = [], url, geo, info, category } = offer;
  const firstPhoto = photos[0];
  const price = React.useMemo(() => formatOfferPrice(offer), [offer]);
  const address = React.useMemo(() => redesignedAddressToString(geo.address, category), [category, geo.address]);
  const urlSource = pageTypeSource === 'chat_bot' ? '?source=chat_bot' : '';
  const href = `${url}${urlSource}`;

  const handleClick = React.useCallback(() => onClick(offer, position), [offer, position, onClick]);

  return (
    <article className={styles['offer']} data-testid="RedesignedRecommendationOfferDesktop">
      <div className={styles['gallery']}>
        <a className={styles['gallery-link']} onClick={handleClick} href={href} target="_blank" rel="noreferrer">
          {firstPhoto && (
            <img className={styles['image']} src={firstPhoto.url} alt="" loading="lazy" decoding="async" />
          )}
        </a>
        {labels}
        <div className={styles['favorite']}>{favoriteButton}</div>
      </div>

      <LinkArea className={styles['info']} href={href} rel="noreferrer" target="_blank" onClick={handleClick}>
        <span className={styles['facts']}>
          <span className={styles['price']}>{price}</span>
          {info && <span className={styles['description']}>{info}</span>}
        </span>
        <span className={styles['location']}>
          {geoInformation && <span className={styles['geo']}>{geoInformation}</span>}
          {address && <span className={styles['address']}>{address}</span>}
        </span>
      </LinkArea>
    </article>
  );
};

export const RecommendationOfferDesktopWithHover = RecommendationOfferDesktop;
